import { render, staticRenderFns } from "./FormSemiNuevos.vue?vue&type=template&id=66ad3bed&"
import script from "./FormSemiNuevos.vue?vue&type=script&lang=js&"
export * from "./FormSemiNuevos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports